import HeartFilledIcon from '@tradera/blueprint/theme/icons2/heart-fill.svg?jsx';
import { useTranslator } from 'tradera/lang/translate';
import { classNames } from 'tradera/utils/class-names';
import {
    Button,
    type ButtonProps
} from 'tradera/components/atoms/button/button';
import styles from './wish-list-button.module.scss';

type WishListButtonProps = Pick<
    ButtonProps,
    'theme' | 'variant' | 'className' | 'onClick'
> & {
    showText?: boolean;
    toggled: boolean | undefined | null;
};

export const WishListButton = ({
    className,
    onClick,
    showText,
    theme,
    variant,
    toggled
}: WishListButtonProps) => {
    const { t } = useTranslator();
    const text = toggled
        ? t('itemCard_savedToWishlist')
        : t('itemCard_saveToWishlist');

    const iconClasses = classNames('icon icon-stroke-white', {
        'icon-danger': toggled,
        'icon-before': showText,
        'icon-md': !showText
    });

    return (
        <Button
            aria-label={text}
            round={!showText}
            size={showText ? undefined : 'xs'}
            className={classNames(styles.button, className)}
            theme={theme ?? (showText ? 'primary' : 'unbutton')}
            variant={variant ?? (showText ? 'outline' : undefined)}
            onClick={onClick}
            icon={
                toggled ? (
                    <HeartFilledIcon className={iconClasses} />
                ) : (
                    <>
                        <HeartFilledIcon
                            className={classNames([
                                iconClasses,
                                styles.iconDark50,
                                styles.hoverHide
                            ])}
                        />
                        <HeartFilledIcon
                            className={classNames([
                                iconClasses,
                                'icon-danger',
                                styles.hoverShow
                            ])}
                        />
                    </>
                )
            }>
            {showText && <span>{text}</span>}
        </Button>
    );
};
